import { defineNuxtPlugin } from '#imports'

import { useUpdateTrackingUserContext } from '../composables/useUpdateTrackingUserContext/useUpdateTrackingUserContext'

export default defineNuxtPlugin((nuxtApp) => {
  const { updateTrackingUserContext } = useUpdateTrackingUserContext()

  nuxtApp.hook('oauth:user-fetched', async () => {
    await updateTrackingUserContext()
  })
})
